import React from 'react';
import {TranslationContext} from "../translations/context";

const PricegroupSelect = (props) => {
    const {selectedTimespan, handleSelectedTimespanChange, selectedResource} = props;
    const {t} = React.useContext(TranslationContext);

    return <select
        value={selectedTimespan || ''}
        onChange={handleSelectedTimespanChange}
    >
        <option key="resource-0" value="none">{t('please_choose')}</option>
        {(!selectedResource || selectedResource.pricegroup.fee_day !== undefined) &&
            <option value="day">{t('day')}</option>}
        {(!selectedResource || selectedResource.pricegroup.fee_week !== undefined) &&
            <option value="week">{t('week')}</option>}
        {(!selectedResource || selectedResource.pricegroup.fee_month !== undefined) &&
            <option value="month">{t('month')}</option>}
        {(!selectedResource || selectedResource.pricegroup.fee_quarter !== undefined) &&
            <option value="quarter">{t('quarter')}</option>}
        {(!selectedResource || selectedResource.pricegroup.fee_year !== undefined) &&
            <option value="year">{t('year')}</option>}
        {(!selectedResource || selectedResource.pricegroup.fee_ten_years !== undefined) &&
            <option value="ten_years">{t('ten_years')}</option>}
    </select>
};

export default PricegroupSelect;
